export const CHALLENGE_TEMPLATE_STATUS_DRAFT = 'Draft';
export const CHALLENGE_TEMPLATE_STATUS_PUBLISHED = 'Published';
export const CHALLENGE_TEMPLATE_STATUS_CUSTOM = 'Custom';
export const CHALLENGE_TEMPLATE_STATUSES = [
    CHALLENGE_TEMPLATE_STATUS_PUBLISHED,
    CHALLENGE_TEMPLATE_STATUS_DRAFT,
    CHALLENGE_TEMPLATE_STATUS_CUSTOM,
];
